import { call, put } from 'redux-saga/effects';
import { fetchBrands } from '../../api';
// import { doShowLoading, doHideLoading, doShowResponse } from '../actions/ui';
import { doSaveBrands } from '../actions';
// import messages from '../enum/messages';
import httpStatuses from '../../constants/httpStatuses';

function* handleFetchBrands() {
  // yield put(doShowLoading());

  try {
    const { data, status } = yield call(fetchBrands);

    if (status !== httpStatuses.OK) {
      // yield put(doShowResponse('error', messages.FE_006));
    } else {
      yield put(doSaveBrands(data));
    }
  } catch (e) {
    // yield put(doShowResponse('error', messages.FE_006));
  }

  // yield put(doHideLoading());
}

export { handleFetchBrands };
